export default [
  {
    path: "after-sale/market-punch",
    name: "MarketPunch",
    component: () => import("@/pages/AfterSale/MarketPunch.vue"),
    meta: {
      title: "市场打卡记录",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/afterSale.js